import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonDatetime } from '@ionic/vue'
//Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'AppDateTime',
  props: {
  presentation: {
    type: String,
    required: false,
    default: () => { return 'date-time' }
  }
},
  emits: ['valueChanged', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



//Props


//Functions
function handleChange(event: any) {
  emit('valueChanged', event)
  emit('update:modelValue', event.detail.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonDatetime), {
    max: "2222-05-31T23:59:59",
    presentation: props.presentation,
    onIonChange: _cache[0] || (_cache[0] = ($event: any) => (handleChange($event)))
  }, null, 8, ["presentation"]))
}
}

})